'use client'
import FormGroup from '@/components/atoms/forms/FormGroup'
import InputErrorText from '@/components/atoms/forms/InputErrorText'
import InputGroup from '@/components/atoms/forms/InputGroup'
import { Label } from '@/components/atoms/forms/Label'
import { Icon } from '@/components/atoms/icon/Icon'
import { classNames } from '@/components/shared/classNames'
import React, { ChangeEvent, useState } from 'react'
import style from './FormInput.module.scss'

interface FormInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  name: string
  label: string | React.ReactNode
  type:
    | 'text'
    | 'password'
    | 'email'
    | 'number'
    | 'tel'
    | 'url'
    | 'search'
    | 'date'
    | 'time'
    | 'datetime-local'
    | 'month'
    | 'week'
  placeholder: string
  value: string | number
  isValid?: boolean
  errorText?: string
  required?: boolean
  onChange: (event: ChangeEvent<HTMLInputElement>) => any
}

const FormInput = React.forwardRef(
  (
    { name, label, placeholder, type, value, isValid = true, required, className, errorText, onChange }: FormInputProps,
    ref
  ) => {
    const [isFocused, setIsFocused] = useState(false)
    const [showPass, setShowPass] = useState(false)

    const handleFocus = () => {
      setIsFocused(true)
    }

    const handleBlur = () => {
      setIsFocused(false)
    }

    const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
      onChange(event)
    }

    const isPassword = type === 'password'
    const inputType = type === 'password' && showPass ? 'text' : type

    return (
      <FormGroup className={className}>
        <Label isFocused={isFocused} isValid={isValid} hidden={!label} htmlFor={name}>
          {label}
        </Label>
        <InputGroup>
          <input
            className={classNames(style.input, isValid ? '' : style['input--invalid'])}
            // id={name}
            name={name}
            autoComplete="off"
            value={value}
            type={inputType}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onChange={handleOnChange}
            placeholder={isFocused ? '' : required ? '* ' + placeholder : placeholder}
          />
          {isPassword && (
            <button
              type="button"
              className={style['input--toggle-password']}
              onClick={() => {
                setShowPass(!showPass)
              }}
            >
              <Icon name={showPass ? 'eyeSlash' : 'eye'} title={showPass ? 'Ocultar' : 'Mostrar'} />
            </button>
          )}
          <InputErrorText>{errorText}</InputErrorText>
        </InputGroup>
      </FormGroup>
    )
  }
)

FormInput.displayName = 'FormInput'
export default FormInput
